export const VIDEO_STORY_PLAYBACK_TEMPLATE = 'VideoStoryPlaybackInterface.v1_0.VideoStoryPlaybackTemplate';
